module.exports = __webpack_public_path__ + "img/svg/american-express.e87999563c679b9db40456271cef58b7.svg";